import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import noImage from '../../../assets/images/no-image.png';
import { checkStatus, shortenandHoverString } from '../../helper';

function ColourWayRefCard({ item, index, onCheck, onDelete, selectedIds, isImport, isSupplierLoggedIn, isProductArchived, disabled }) {
  const [element, setElement] = useState(null);
  const { t } = useTranslation('colourGroup');

  const isChecked = selectedIds.filter((val) => val === item._id).length > 0;

  useEffect(() => {
    setElement(item);
  }, [item]);

  return (
    <div id="accordion" className="col-lg-3 mt-35 mb-24" key={index}>
      <div className="common-listing-card bom-new-card card">
        <div className="card-header padding-right-image">
          {!isSupplierLoggedIn && !isProductArchived && (
            <ul className="card-header-icon bom-card-header ">
              <li>
                <div className="common-checkbox">
                  <input
                    onChange={(e) => {
                      onCheck(e, item._id, index);
                    }}
                    name={`check_${index}`}
                    id={`check_${index}`}
                    type="checkbox"
                    checked={isChecked}
                    disabled={disabled}
                  />
                  <label htmlFor={`check_${index}`} className="chklabel" />
                </div>
              </li>
              <li className="px-0">
                <button
                  className="btn btn-action-icon mx-0 mb-1"
                  disabled={disabled}
                  title={t('COMMON_LABEL.DELETE')}
                  onClick={() => {
                    onDelete(element._id);
                  }}
                  type="button"
                >
                  <i className="icon-Delete f-28" />
                </button>
              </li>
            </ul>
          )}
          <div className="image-detail bom-image">
            <div className="card-image-preview" style={{ backgroundImage: `url(${element?.image || noImage})` }} />
            <span style={{ backgroundImage: `url(${element?.image || noImage})` }} className="big-image" />
          </div>
        </div>
        <div className="card-body">
          <h4 className="title font-heavy">{element?.name ? element.name : ''}</h4>
          <ul className="card-ul">
            <li>
              <p className="mb-0">
                <span className="font-heavy">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.DESCRIPTION')}:&nbsp;</span>
                <span className="font-book mb-0">{element?.description ? shortenandHoverString(element.description, 20) : ''}</span>
              </p>
            </li>
          </ul>
        </div>
        {isImport ? <div className={`status ${checkStatus(element)}`} /> : null}
      </div>
    </div>
  );
}

export default ColourWayRefCard;
